// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"120":"314f0ff4","775":"84707e6b","946":"71a0e15e","995":"b2aa14dc"}[chunkId] + ".js";
};